"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactEmotion = require("react-emotion");

var loading = function loading() {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("position:absolute;top:0;bottom:0;left:0;right:0;display:flex;align-items:center;justify-content:center;background-color:transparent;z-index:1;")
  );
};

var _default = loading;
exports.default = _default;